import $ from "jquery";

export const fetchFilterState = (csvFilterId, filters, locale) => {
  const params = filters
    .reduce((queryString, filter) => {
      if (filter.showAsInterval) {
        if (filter.minValue != "") {
          queryString[`${filter.key}_min`] = filter.minValue;
        }
        if (filter.maxValue != "") {
          queryString[`${filter.key}_max`] = filter.maxValue;
        }
      } else if (filter.showAsMinText) {
        if (filter.minValue != "") {
          queryString[`${filter.key}_min`] = filter.minValue;
        }
      } else if (filter.showAsMaxText) {
        if (filter.maxValue != "") {
          queryString[`${filter.key}_max`] = filter.maxValue;
        }
      } else {
        if (filter.value != undefined && filter.value.length > 0) {
          queryString[filter.key] = filter.value;
        }
      }
      return queryString;
    }, { locale: locale });

  return $.get(`/api/v2/csv_filters/${csvFilterId}.json`, $.param(params));
};

export const addProduct = productId =>
  $.ajax({
    url: `/api/v2/basket_products.json`,
    type: "POST",
    beforeSend: request => {
      const csrfToken = document.querySelector("meta[name=csrf-token]").content
      request.setRequestHeader("X-CSRF-Token", csrfToken);
    },
    data: JSON.stringify({
      basket_product: {
        product_id: productId,
      }
    }),
    contentType: "application/json"
  });

export const removeProduct = productId =>
  $.ajax({
    url: `/api/v2/basket_products/${productId}.json`,
    type: "DELETE",
    beforeSend: request => {
      const csrfToken = document.querySelector("meta[name=csrf-token]").content
      request.setRequestHeader("X-CSRF-Token", csrfToken);
    },
    contentType: "application/json"
  });

export const generateEntries = (selectInRevitUrl, channel, entryGuids) => {
  return $.ajax({
    url: selectInRevitUrl,
    type: "POST",
    beforeSend: request => {
      const csrfToken = document.querySelector("meta[name=csrf-token]").content
      request.setRequestHeader("X-CSRF-Token", csrfToken);
    },
    data: JSON.stringify({
      channel: channel,
      entry_guids: entryGuids
    }),
    contentType: "application/json"
  });

}